"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.search.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _training = require("@/api/training");
var _user = require("@/api/user");
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _index = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ILTAttendance',
  components: {
    SearchBox: _index.default
  },
  mixins: [_autoTableHeight.autoTableHeight],
  filters: {
    getProducerName: function getProducerName(value) {
      return _lodash.default.map(value, function (p) {
        return p.name;
      });
    },
    getProducerStaff: function getProducerStaff(value, staffList) {
      var plist = _lodash.default.map(_lodash.default.flatten(_lodash.default.map(_lodash.default.filter(value, {
        role: 'producer'
      }), function (p) {
        return _lodash.default.filter(staffList, {
          user: p.user
        });
      })), function (n) {
        return n.name;
      }).toString();
      return plist;
    }
  },
  data: function data() {
    return {
      tableLoading: false,
      trainingStatus: _lifehikesInitData.trainingStatus,
      myProducedTraining: false,
      countryList: [],
      trainingList: [],
      staffList: [],
      total: 0,
      query: {
        page: 1,
        limit: 50,
        sort: '-createdAt',
        q: undefined,
        /* title: undefined,*/
        country: undefined,
        publish: undefined,
        staffRole: undefined,
        staffUuid: undefined
      }
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            (0, _log.showDebugLog)('Training- list-create', 'created');
            _this.$store.dispatch('facets/getInitData', 'en').then(function () {
              _this.countryList = _this.$store.getters.countries;
            });
            _context.n = 1;
            return _this.getStaffList();
          case 1:
            _context.n = 2;
            return _this.getList();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _log.showDebugLog)('Training query', this.query);
      (0, _training.getTrainingList)(token, this.query).then(function (response) {
        (0, _log.showDebugLog)('Training-Search-response', response);
        _this2.trainingList = response.data.rows;
        _this2.total = response.data.count;
        _this2.tableLoading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('Training-Search-error', error);
        _this2.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    getStaffList: function getStaffList() {
      var _this3 = this;
      this.loading = true;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var query = {
        page: 1,
        limit: 100,
        role: 'otr-digital-producer',
        sort: 'givenName'
      };
      (0, _user.getUserList)(token, query).then(function (response) {
        _this3.loading = false;
        _this3.staffList = response.data.rows.map(function (s) {
          return {
            user: s.uuid,
            name: "".concat(s.givenName, " ").concat(s.familyName)
          };
        });

        // console.log('Staff List', this.staffList)
      }).catch(function (error) {
        _this3.loading = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    search: function search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.query.publish = this.query.publish === '' ? undefined : this.query.publish;
      this.query.country = this.query.country === '' ? undefined : this.query.country;
      this.query.staffUuid = this.query.staffUuid === '' ? undefined : this.query.staffUuid;
      this.getList();
    },
    setMyTraining: function setMyTraining() {
      // const uuid = utils.getUserUuid()
      if (this.query.staffUuid) {
        this.query.staffRole = 'producer';
        // this.query.staffUuid = uuid
      } else {
        this.query.staffRole = undefined;
        this.query.staffUuid = undefined;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$parent.$emit('onSelectionChange', val);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    sort: function sort(data) {
      var prop = data.prop,
        order = data.order;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'start') {
        order === 'ascending' ? this.query.sort = '+start.utc' : this.query.sort = '-start.utc';
      }
      if (prop === 'end') {
        order === 'ascending' ? this.query.sort = '+end.utc' : this.query.sort = '-end.utc';
      }
      if (prop === 'description') {
        order === 'ascending' ? this.query.sort = '+description' : this.query.sort = '-description';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      if (prop === 'internal.title') {
        order === 'ascending' ? this.query.sort = '+internal.title' : this.query.sort = '-internal.title';
      }
      if (prop === 'internal.opportunityNumber') {
        order === 'ascending' ? this.query.sort = '+internal.opportunityNumber' : this.query.sort = '-internal.opportunityNumber';
      }
      this.search(1);
    },
    disableVisble: function disableVisble(id) {
      this.$refs[id].visible = false;
    }
  }
};